import React from 'react'
import {NavLink} from 'react-router-dom';

function Sidebar() {
    const activeClassName = 'nav-link';
    const inactiveClassName = 'nav-link collapsed';
    return (
        <>
            <aside className="sidebar">
                <ul className="sidebar-nav">
                    <li className="nav-heading">General</li>
                    <li className="nav-item">
                        <NavLink to="dashboard"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>
                            <i className="bi bi-speedometer2"></i>
                            <span> Dashboard</span>
                        </NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to="clinics"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>
                            <i className="bi bi-hospital"></i>
                            <span> Clinics</span>
                        </NavLink>

                    </li>

                    <li className="nav-item">
                        <NavLink to="articles"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>
                            <i className="bi bi-file-medical"></i>
                            <span> Articles</span>
                        </NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to="surveys"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>

                            <i className="bi bi-clipboard-data"></i>
                            <span> Surveys</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="campaign"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>

                            <i className="bi bi-megaphone"></i>
                            <span> Campaigns</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="recalls"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>

                            <i className="bi bi-repeat"></i>
                            <span> Recalls</span>
                        </NavLink>
                    </li>
                    <li className="nav-heading">Templates</li>
                    <li className="nav-item">
                        <NavLink to="admin-templates"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>

                            <i className="bi bi-file-earmark-medical"></i>
                            <span> EyeconX Templates</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="install-templates"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>

                            <i className="bi bi-cloud-arrow-down"></i>
                            <span> Install Templates</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="clinic-templates"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>

                            <i className="bi bi-file-earmark-medical"></i>
                            <span> Clinic Templates</span>
                        </NavLink>
                    </li>

                    <li className="nav-heading">Admin</li>

                    <li className="nav-item">
                        <NavLink to="process"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>
                            <i className="bi bi-list-task"></i>
                            <span> Process</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="logs"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>
                            <i className="bi bi-journal-text"></i>
                            <span> Scheduled Logs</span>
                        </NavLink>
                    </li>

                    <li className="nav-heading">SMS Gateway</li>
                    <li className="nav-item">
                        <NavLink to="adminsmsgateway"
                                 className={({isActive}) => isActive ? activeClassName : inactiveClassName}>
                            <i className="bi bi-chat"></i>
                            <span> SMS Gateway Stats</span>
                        </NavLink>
                    </li>
                </ul>
            </aside>
        </>
    )
}

export default Sidebar